<template>
  <select
    class="language-select"
    :class="{ 'language-select--workspace': $route.path !== '/' && $route.path !== '/login' }"
    :value="$localeState.locale"
    :aria-label="$t('语言')"
    :title="$t('语言')"
    @change="changeLocale">
    <option v-for="locale in locales" :key="locale.value" :value="locale.value">{{ locale.label }}</option>
  </select>
</template>

<script>
import { setLocale, supportedLocales } from '@/i18n';

export default {
  name: 'LanguageSelect',
  data() { return { locales: supportedLocales }; },
  methods: {
    changeLocale(event) { setLocale(event.target.value); },
  },
};
</script>

<style scoped>
.language-select {
  position: fixed;
  top: 12px;
  right: 64px;
  z-index: 3001;
  width: 104px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--surface-color);
  color: var(--text-regular);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
.language-select:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}
.language-select--workspace { top: 18px; right: 72px; height: 40px; z-index: 30; }
@media (max-width: 900px) {
  .language-select--workspace { top: 12px; right: 64px; }
}
@media (max-width: 768px) {
  .language-select { right: 60px; }
}
</style>
